import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import MainLayout from "./layout/MainLayout";
import AdminLayout from "./layouts/AdminLayout";
import Home from "./pages/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Login from "./pages/Login";
import RequireAuth from "./components/RequireAuth";

// ADMIN
import Dashboard from "./pages/admin/Dashboard";
import EventDetail from "./pages/admin/EventDetail";
import EditEvent from "./pages/admin/EditEvent";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminEvents from "./pages/admin/Events";
import AdminExport from "./pages/admin/AdminExport";

// PUBLIC
import EventPublic from "./pages/EventPublic";
import EventsPage from "./pages/EventsPage";
import BookingUpload from "./pages/booking/BookingUpload";
import BookingTicketPage from "./pages/booking/BookingTicketPage";
import PublicTicketPage from "./pages/booking/PublicTicketPage";
import ScanPage from "./pages/scan/ScanTicket";
import BookingPaymentPage from "./pages/booking/BookingPaymentPage";


function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* AUTH */}
        <Route path="/login" element={<Login />} />
        {/* 🔥 UPLOAD BUKTI PEMBAYARAN */}
        <Route path="/booking/:id" element={<BookingUpload />} />
        <Route
          path="/booking/:id/ticket"
          element={<BookingTicketPage />}
        />
        <Route
          path="/scan"
          element={
            <RequireAuth>
              <ScanPage />
            </RequireAuth>
          }
        />
        <Route path="/booking/:id/pay" element={<BookingPaymentPage />} />
        <Route path="/ticket/:code" element={<PublicTicketPage />} />
        

        {/* ADMIN LOGIN - public */}
        <Route path="/admin" element={<Login />} />

        {/* ADMIN PROTECTED */}
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="export" element={<AdminExport />} />
          <Route path="events/:id" element={<EventDetail />} />
          <Route path="events/:id/edit" element={<EditEvent />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Route>

        {/* MAIN PUBLIC LAYOUT */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* PUBLIC */}
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/:id" element={<EventPublic />} />
        </Route>

      </Routes>
    </BrowserRouter>

  );
}

export default App;
